<script lang="ts">
    import clsx from 'clsx';

    export let src = '';
    export let align = 'left';
    export let bgColor = 'transparent';
    export let size: Size = 'medium';
    export let showIcon = true;
    export let onClick: (event: MouseEvent | TouchEvent) => any;

    type Size = 'small' | 'medium' | 'large' | 'xLarge';

    const logoSizeMap: Record<Size, number> = {
        small: 32,
        medium: 40,
        large: 48,
        xLarge: 64,
    };

    let alignClasses: string;
    let imageClasses: string;

    $: rawSrc = src.split('?')[0];
    $: optimizedSrc = `${rawSrc}?h=${logoSizeMap[size]}&dpr=2&q=75&auto=format,compress`;
    $: alignClasses = clsx({
        'text-center': align === 'center',
        'text-left': align === 'left',
    });
    $: imageClasses = clsx('inline-block', {
        clickable: !!onClick,
        'h-8': size === 'small',
        'h-10': size === 'medium',
        'h-12': size === 'large',
        'h-16': size === 'xLarge',
    });
</script>

<div class="border-box w-full p-4 sm:py-6" style="background-color: {bgColor}">
    <div class={alignClasses}>
        <button on:click={onClick} class={!showIcon ? 'invisible' : ''}>
            <img class={imageClasses} src={optimizedSrc} alt="Logo" />
        </button>
    </div>
</div>
